// removed by extract-text-webpack-plugin
module.exports = {"page":"_1zrIKenUZ _30W7J4cYZ gkmejKHip","content":"_6v9ZeGzR0 m_MD8dOe5 kthKJ-hIO M02IhxSCi","centered":"_3F4SpoMJa _3EiT4eWlg _2Kz2o9zH0 _1FoUCLbbD _2l0xl0HVf _2nov6tC6P"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/performance-page/performance-page.css
 ** module id = 2193
 ** module chunks = 0
 **/